import type { Photo } from '@/shared/components/fullScreen/FullScreenImageViewer'

import type { MY_TICKET_TYPE, REPORT_TYPE } from '@/enums/myTicket'

import { ResponseDto } from '@/api/server/common/dto'

export class MyTicketDetailParamsDto {
  type!: MY_TICKET_TYPE
  seq!: number
}
export class MyTicketDetailQueryDto {
  guestCode?: string
}

export class MyTicketDetailDto extends ResponseDto {
  data!: {
    parkinglot: {
      type: string
      seq: number
      name: string
      address: string
      latitude: number
      longitude: number
      phone: string
    }
    ticket: {
      type: MY_TICKET_TYPE
      paymentTime: Date
      seq: number
      // null 인경우 '' 로 삽입
      paymentType: string | ''
      totalPrice: number
      addonPrices: {
        addonPolicyType: number
        price: number
      }[]
      ticketName: string
      carNum: string
      usageDate: string
      refunds: Array<{
        requestSeq: number
        requestType: string
        requestStatus: number
        createdAt: Date
        refundedAt: Date | null
      }>
      status: string
      // paymentSeq (영수증용)
      paymentSeq: number
      // 사용시간, 주차시간
      usageTime: string
      // 이용방법
      usageGuide: string
      // 안내사항
      notice: string
      // 유의사향
      notice2: string
      // 사진
      photos: Photo[]
      // 결제취소 가능여부
      isCancelable: boolean
      // 주차권 환불신청 가능여부
      isTicketRefundable: boolean
      // 현장결제 환불신청 가능여부
      isOnSiteRefundable: boolean
      // 결제환불 템플릿
      refundRequestTemplate: string
      refundRequestTemplateKeys: string[]
      // 공유전용
      share: null | {
        endTime: Date
        usageTypeGuide: string
        isExtendable: boolean
        extendableMinute: number
        detailType: string
        isExtend: boolean
        usingTime: number
      }
      // 제휴주차권 전용
      partner: null | {
        // 결제시 필요
        couponTypeSeq: number
        predictTime: string
        // 월주차권 전용
        monthlyInfo: MonthlyInfo | null
        isNeedConfirm: boolean
        isWebDiscountTicket: boolean
        isTicketApplied: boolean
        isEntered: boolean
        isPayAfterEntered: boolean
        enterTime: Date | null
        isExpired: boolean
        //단기권
        reserveDate: Date | null
        reserveEndDate: Date | null
        predictEndTime: string
        labels: string[]
        userInput?: string | null
        userInputTemplate?: string | null
        //이용자 입력정보 수정 가능 기간
        userInputEditableUntil: Date | null
      }
    }
    canceledDate: null | Date
  }
}

export class MonthlyInfo {
  cmouSeq!: number
  copSeq!: number
  userName!: string
  userPhone!: string
  carModel!: string
  carNum!: string
  startedAt!: Date
  finishedAt!: Date
  isExtension!: boolean
  extensionInfo!: null
}

export class RequestCancelPaymentPayload {
  guestCode!: string
}

export class ShareRequestCancelPaymentPayload extends RequestCancelPaymentPayload {
  reportType!: REPORT_TYPE
}
export class RequestCancelPaymentAuth {
  token!: string
}

export class RequestCancelPaymentPathVar {
  seq!: number
}

export class RequestCancelPaymentResDto extends ResponseDto {
  data!: {
    canceledDate: string
    success: boolean
  }
}

export class RequestUseMyTicketPayload {
  couSeq!: number
  guestCode!: string
}

export class RequestUseMyTicketAuth {
  token!: string
}

export class UseMyTicketResDto extends ResponseDto {
  data!: {
    couSeq: string
  }
}

export class GetMyTicketDetailPathVar {
  type!: string
  seq!: string
  guestCode!: string
}

export class GetMyTicketDetailAuth {
  token!: string
}

export class RequestUserInputPathVar {
  couSeq!: string
}

export class RequestUserInputPayload {
  userInputJson!: string
}

export class RequestUserInputAuth {
  accessToken!: string
}
